<template>
    <div
        class="status-indicator-root d-flex align-items-center justify-content-center pointer"
        :class="{ 'pending-color': pending }"
    >
        <BaseIcon
            class="status-icon"
            name="exclamation"
            :class="{ 'pending-color': pending }"
        />
    </div>
</template>

<script>
export default {
    name: 'StatusIndicator',
    props: {
        pending: Boolean,
    },
};
</script>

<style scoped>
.status-indicator-root {
    box-sizing: border-box;
    border-width: 3px;
    border-style: solid;
    border-radius: 50%;
    background-color: white;

    position: relative;
    cursor: pointer;

    width: 38px;
    height: 38px;
    color: var(--error);
}
.status-icon {
    font-size: 16px;
}
</style>
